import PermissionsView from "./permissions-view.jsx";
import usePermissionsTable from "./usePermissionsTable.js";

export { usePermissionsTable };
export default PermissionsView